export default "__VITE_ASSET__650c78f9__"